var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Log } from '../../log';
import { AdvancedHttpRequest } from './drivers/framework/AdvancedHttpRequest';
const debug = false;
const log = Log.channel('SynergySky');
const meetingTypes = {
    googleMeet: 'GoogleMeet',
    teams: 'Teams',
    zoom: 'Zoom',
};
const teamsMeetingCodeRegex = /([a-z0-9]+)(?:##([a-z0-9]+))?$/i;
export function dialStringIsInSynergySkyFormat(apiDomain, dialString) {
    const preformattedDialStringRegExp = new RegExp(`[tgz]\.[^@]+@${apiDomain}`, 'i');
    return preformattedDialStringRegExp.test(dialString);
}
function parseTeamsMeetingCode(dialString, displayDialString) {
    let match = dialString.startsWith('http') ? null : teamsMeetingCodeRegex.exec(dialString);
    if (!match)
        match = teamsMeetingCodeRegex.exec(displayDialString || '');
    if (match) {
        let newDialString = match[1];
        if (match[2])
            newDialString += `##${match[2]}`;
        return newDialString;
    }
    return undefined;
}
export function manuallyProvisionMeeting(apiDomain, tenantId, clientSecret, callType, dialString, displayDialString, meetingCode) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const httpRequest = AdvancedHttpRequest;
        let token = '';
        dialString = dialString.replace(/\s+/g, '');
        displayDialString = displayDialString === null || displayDialString === void 0 ? void 0 : displayDialString.replace(/\s+/g, '');
        meetingCode = meetingCode === null || meetingCode === void 0 ? void 0 : meetingCode.replace(/\s+/g, '');
        if (callType === 'teams') {
            dialString = (_a = parseTeamsMeetingCode(dialString, displayDialString)) !== null && _a !== void 0 ? _a : dialString;
        }
        let meetingId;
        let meetingPassword;
        [meetingId, meetingPassword] = dialString.split('##');
        if (meetingPassword === undefined)
            meetingPassword = meetingCode;
        meetingPassword = meetingPassword !== null && meetingPassword !== void 0 ? meetingPassword : 'null';
        try {
            yield httpRequest.acceptAllCerts(true);
        }
        catch (error) {
            log.warning(`manuallyProvisionMeeting: failed setting up https request: ${error}`);
            return undefined;
        }
        try {
            const authResp = yield httpRequest.sendRequest({
                data: { tenantId, clientSecret },
                headers: { 'Content-Type': 'application/json' },
                host: apiDomain,
                method: 'post',
                path: '/gatewayprovisioning/api/provisioning/auth/gettoken/',
                scheme: 'https',
                serializer: 'json',
            });
            if (authResp.status !== 200) {
                log.warning(`manuallyProvisionMeeting: failed authentication: ${JSON.stringify(authResp)}`);
                return undefined;
            }
            if (debug) {
                log.debug(`authResp = ${JSON.stringify(authResp, null, 4)}`);
            }
            log.info(`successfully authenticated for ${callType} "${dialString}`);
            token = JSON.parse(authResp.data || '');
        }
        catch (error) {
            log.warning(`manuallyProvisionMeeting: failed authentication: ${error}`);
        }
        try {
            const now = Date.now();
            const start = new Date(now).toISOString();
            const end = new Date(now + 60 * 60 * 1000).toISOString();
            const meetingTypeIdentifier = meetingTypes[callType];
            if (meetingTypeIdentifier === undefined) {
                log.error(`unsupported synergy sky call type: ${callType}`);
                return undefined;
            }
            const data = {
                plannedStartAt_utc: start,
                plannedEndAt_utc: end,
                meetingTypeIdentifier,
                meetingId,
                meetingPassword,
                isExternalOrganizer: true,
                tenantId,
                meetingisactive: true,
            };
            if (debug)
                log.debug(`provisioning data = ${JSON.stringify(data, null, 4)}`);
            const provResp = yield httpRequest.sendRequest({
                data,
                headers: {
                    'x-api-version': '2.0',
                    Authorization: `Bearer ${token}`,
                },
                host: apiDomain,
                method: 'post',
                path: '/gatewayprovisioning/api/provisioning/gateways/new',
                scheme: 'https',
                serializer: 'json',
            });
            if (provResp.status !== 200) {
                log.warning(`manuallyProvisionMeeting: failed provisioning: ${JSON.stringify(provResp)}`);
                return undefined;
            }
            if (debug) {
                log.debug(`provResp = ${JSON.stringify(provResp, null, 4)}`);
            }
            log.info(`successfully provisioned ${callType} "${dialString}"`);
            try {
                const data = provResp.data ? JSON.parse(provResp.data) : {};
                if (typeof data === 'object' &&
                    data !== null &&
                    'endpointDialUri' in data &&
                    typeof data.endpointDialUri === 'string') {
                    meetingId = data.endpointDialUri;
                }
                else {
                    throw new Error(`missing or invalid endpointDialUri`);
                }
            }
            catch (error) {
                log.warning(`failed parsing endpointDialUri from data "${provResp.data}": ${error}`);
            }
        }
        catch (error) {
            log.warning(`manuallyProvisionMeeting: failed provisioning: ${error}`);
        }
        return meetingId;
    });
}
export function translateSynergySkyCall(domain, callType, dialString, displayDialString) {
    if (callType === 'pstn' || callType === 'voip' || callType === 'video') {
        log.error(`unsupported synergy sky call type: ${callType}`);
    }
    else if (callType === 'googleMeet') {
        dialString = `g.${dialString}@${domain}`; // TODO: add support for google meet
    }
    else if (callType === 'teams') {
        const meetingCode = parseTeamsMeetingCode(dialString, displayDialString);
        if (meetingCode !== undefined)
            return `t.${meetingCode}@${domain}`;
        log.error(`invalid teams dial string: ${dialString}`);
        return dialString;
    }
    else if (callType === 'zoom') {
        dialString = `z.${dialString}@${domain}`;
    }
    else {
        log.error(`unhandled synergy sky call type: ${callType}`);
    }
    return dialString;
}
